<a
  class="file-item"
  [class.locked]="!hasAccess()"
  [attr.href]="hasAccess() ? file().file_url : null"
  [attr.download]="hasAccess() ? '' : null"
  [attr.target]="hasAccess() ? '_blank' : null"
  dataTest="file-item"
>
  <div class="icon-block">
    <div
      class="icon"
      [class.outlaw-icon-download]="hasAccess()"
      [class.outlaw-icon-lock]="!hasAccess()"
      dataTest="file-item-icon"
    ></div>
  </div>

  <div class="data">
    @if (file().file_name) {
      <div class="title" [title]="file().file_name" dataTest="file-item-title">
        {{ file().file_name | textSlice }}
      </div>
    }
    @if (file().file_size) {
      <div class="size" dataTest="file-item-size">
        {{ file().file_size | filesize }}
      </div>
    }
  </div>
</a>
